export default __webpack_public_path__ + "static/media/study-small-white.617ef2de.svg";